/*
 * Modules
 *
 * @author Nalin Ahuja
 * @created 2013-09-19
 */
import { AccessibilityController } from './legacy/controllers'
import Common from './common'
import mobileMenu from '../mobileMenu'
import Utils from '../utils/utils'
import $ from 'jquery'
import { helper, events } from './versions/v2/eventHandler'

function _init() {
    var obj = $('.mediaType')
    if (obj.data('containertype') === MediaModules.containerTypes.LOCATION) {
        MediaModules.init({
            locid: obj.data('locid'),
            instid: obj.data('instid'),
            tourid: obj.data('tourid'),
            containerType: obj.data('containertype'),
            mediaType: obj.data('mediatype'),
            singleMedia: obj.data('singlemedia'),
            autoPlay: obj.data('autoplay'),
            shortUrl: obj.data('shorturl'),
            embed: obj.data('embed'),
            hideMenuBar: obj.data('hidemenubar'),
        })
    }
}

var MediaModules = {
    locid: null,
    containerType: null,
    mediaType: null,
    versionType: null,
    stopid: null,
    instid: null,
    tourid: null,
    sendStopAnalytics: false,
    singleMedia: false, // indicates if the container will only be exclusive to one Media element
    currentStopId: null,

    containerTypes: {
        LOCATION: 'location',
        STOP: 'stop',
    },

    mediaTypes: {
        PANO: 'panoramas',
        PHOTO: 'photos',
        VIDEO: 'videos',
    },

    IMAGE_CACHE_SIZE: 3,

    _getCurrentStopCB: null,
    _mediaShare: true,
    _panoPlayer: null,
    _videoPlayer: null,
    _showModule: null,
    _hideDescription: true,
    panelVisible: false,
    cache_index: -1,
    totalMedia: 0,
    _mediaPanel: null,

    // calbacks and events
    _onAudioStopCb: [],
    _onCloseCb: [],
    _onOpenCb: [],
    _onAudioPlayCb: [],

    GALLERY_PANEL: 'media-side-bar',
    PLAYER_PANEL: 'main-media-section',

    init: function(options) {
        this.locid = options.locid
        this.containerType = options.containerType
        this.setMediaType(options.mediaType)
        this.isAda = options.isAda || false
        this.instid = options.instid
        this.tourid = options.tourid
        this.mediaTarget = options.mediaTargetId ? options.mediaTargetId : 'media'
        this.mediaTargetId = '#' + this.mediaTarget
        this._mediaPanel = $(this.mediaTargetId)
        this._mediaShare = typeof options.shareOn !== 'undefined' ? options.shareOn : true
        this.autoPlay = options.autoPlay == 1

        if (this.containerType == this.containerTypes.STOP) {
            this._getCurrentStopCB = options.currentStopCallback
            this.sendStopAnalytics = options.sendStopAnalytics || false
            this._addHooks()
        } else {
            this.singleMedia = options.singleMedia == 1
            this.loadMedia()
            $(document).on('menuInitialized', function() {
                $('.mobile-right-button,.mobile-right-button a').addClass('filteroff')
            })
            mobileMenu.init(this.GALLERY_PANEL, 'container', !this.singleMedia)
            var hasMediaTarget = Utils.getParameterByName('id') != ''
            this._showMedia(!hasMediaTarget)
        }

        this.addEvents()

        if (options.embed && options.shortUrl) {
            var stm = shareTourModal(
                options.embed
                    .replace(/&lt;/g, '<')
                    .replace(/&gt;/g, '>')
                    .replace(/&amp;/g, '&')
                    .replace(/\\n/g, '\n'),
                options.shortUrl,
                options.loc_id
            )
            $(this.mediaTargetId)
                .find('#preview_prompt button')
                .click(function() {
                    stm.show()
                })
        }

        return this
    },

    loadMedia: function() {
        var mediaObj = $('.mediaType'),
            scope = this,
            params = {
                mediaType: this.mediaType,
                locid: this.locid,
                instid: this.instid,
                tourid: this.tourid,
                id: mediaObj.data('mediaid'),
                startOffset: mediaObj.data('mediastartindex'),
            }
        if (mediaObj.data('loadmore')) {
            $.ajax({
                type: 'GET',
                url: '/tour/MediaModules/loadPrev',
                data: params,
                success: function(data) {
                    $('ul.media-thumb-list').prepend(data)
                    scope._loadMedia()
                    scope._scroll()
                },
            })

            $.ajax({
                type: 'GET',
                url: '/tour/MediaModules/loadMore',
                data: params,
                success: function(data) {
                    $('ul.media-thumb-list').append(data)
                    scope._loadMedia()
                    scope._scroll()
                },
            })
        } else {
            this._loadMedia()
        }
        $('.description-box').mCustomScrollbar({
            advanced: {
                updateOnContentResize: true,
            },
        })
    },

    setMediaType: function(mediaType) {
        this.mediaType = mediaType

        if (this.mediaType == this.mediaTypes.PHOTO) {
            this._showModule = this._showPhoto.bind(this)
        } else if (this.mediaType == this.mediaTypes.PANO) {
            // If ADA version: bind to _showPhoto function
            // If Original version: bind to _showPano function
            if (this.isAda) {
                this._showModule = this._showPhoto.bind(this)
            } else {
                this._showModule = this._showPano.bind(this)
            }
        } else if (this.mediaType == this.mediaTypes.VIDEO) {
            this._showModule = this._showVideo.bind(this)
        }
        window.onMediaType && window.onMediaType(mediaType)
    },

    addEvents: function() {
        var scope = this

        $(document).on('click', 'div.imgthumb', function(e) {
            e.preventDefault()
            $('div.imgthumb').removeClass('active')
            $(this).addClass('active')
            scope._showMedia()
        })

        $('a.nextmedia').click(function() {
            window.onNextMedia && window.onNextMedia()
            scope._nextMedia()
        })

        $('a.previousmedia').click(function() {
            scope._previousMedia()
        })

        $('a.info-button').click(function(e) {
            window.onInfoIconClicked && window.onInfoIconClicked(scope.mediaType)

            if ($('.description-box').is(':visible')) {
                $('.description-box').hide()
                scope._hideDescription = true
            } else {
                $('.description-box').show()
                scope._hideDescription = false
            }
        })
        var desktopParams = {
                shareButton: $('.share-container.modules .share-object .share-btn'),
                shareLi: $('.share-container.modules .share-object ul.social-icons li'),
            },
            mobileParams = {
                shareButton: $('.menu-scrolling-items .share-object .share-btn'),
                shareLi: $(
                    '.menu-scrolling-items .share-object ul.social-icons li, .share-object.share-btn-mobile-menu li'
                ),
            }
        if (this._mediaShare) {
            Common &&
                Common.registerShareObject(
                    desktopParams,
                    mobileParams,
                    function(param) {
                        var url = '',
                            query = UrlUtils.queryString(
                                $('.active.imgthumb')
                                    .find('a')
                                    .attr('href')
                            ),
                            id = 'id=' + query.id,
                            mod = 'module=' + scope.mediaType,
                            imageUrl,
                            shareUrl = $('.active.imgthumb')
                                .find('a')
                                .data('default-url'),
                            longUrl = $('.active.imgthumb')
                                .find('a')
                                .data('alt-url')
                        if (!longUrl)
                            longUrl =
                                location.origin + '/tour/' + scope.mediaType + '/' + scope.instid + '/' + scope.locid

                        if (param) {
                            url += '?' + mod + '&' + id
                        } else {
                            url += '?' + id
                        }

                        if (scope.singleMedia) {
                            url += '&single=1'
                        }

                        if (scope.mediaType === scope.mediaTypes.PHOTO) {
                            imageUrl = encodeURIComponent(
                                $(this.mediaTargetId)
                                    .find('#main-photo')
                                    .attr('src')
                            )
                        } else if (scope.mediaType === scope.mediaTypes.PANO) {
                            imageUrl = encodeURIComponent($('.imgthumb.active').data('pano').path + '512.jpg')
                        } else if (scope.mediaType === scope.mediaTypes.VIDEO) {
                            imageUrl = encodeURIComponent(
                                $('.imgthumb.active')
                                    .find('img')
                                    .attr('src')
                            )
                        }
                        return {
                            params: url,
                            imageUrl: imageUrl,
                            shareUrl: shareUrl || longUrl,
                            longUrl: longUrl,
                        }
                    },
                    true
                )
        } else {
            $('.share-container').hide()
        }
        $('.sidepanelcontrol').click(function(e) {
            if ($('.filter-stop').is(':visible')) {
                $('.filter-stop').hide()
            } else {
                $('.filter-stop').show()
            }
            $('.media-side-bar').toggleClass('expand collapse')
            $('.sidepanelcontrol').toggleClass('expand collapse')
            if (scope.mediaType == scope.mediaTypes.PANO) {
                setTimeout(scope._showPano.bind(scope), 850)
                $('.main-media-section').toggleClass('expand panocollapse')
            } else {
                $('.main-media-section').toggleClass('expand collapse')
            }
        })

        $(window).on('resize.mediaModules', scope._resizeEvent.bind(scope))

        $('select.filter-stop').change(function() {
            var stop = $('select.filter-stop option:selected'),
                stopid = stop.data('stopid'),
                data = {
                    mediaType: scope.mediaType,
                    locid: scope.locid,
                    instid: scope.instid,
                    tourid: this.tourid,
                }
            if (stopid != undefined) {
                data.stopid = stopid
                scope.currentStopId = stopid
            }

            scope._loadStopMedia(data)
        })

        $('.mobile-stops li').click(function() {
            mobileMenu.rightMenu()
            var stopid = $(this)
                    .children()
                    .data('stopid'),
                stopTitle = $(this)
                    .children()
                    .data('stoptitle'),
                data = {
                    mediaType: scope.mediaType,
                    instid: scope.instid,
                    locid: scope.locid,
                    tourid: this.tourid,
                }

            if (stopid != undefined) {
                data.stopid = stopid
                mobileMenu.rightMenuFilterOn()
                scope.currentStopId = stopid
            } else {
                mobileMenu.rightMenuFilterOff()
            }

            $('.mobile-stops li div').removeClass('checkmark')
            $(this)
                .children()
                .addClass('checkmark')
            scope._loadStopMedia(data)
        })

        $('div.currentStop_container').click(function() {
            $('#dropmenudiv').slideToggle()
        })

        if ($(this.mediaTargetId).find('#main-photo').length != 0) {
            $('.info-button').hide()
            $(this.mediaTargetId)
                .find('#main-photo')
                .click(function(e) {
                    scope._nextMedia()
                })
            $(this.mediaTargetId)
                .find('#main-photo')
                .load(function(e) {
                    $(this.mediaTargetId)
                        .find('#main-photo')
                        .removeClass('main-photo-loading')
                    $(this.mediaTargetId)
                        .find('#main-photo')
                        .attr('alt', $('.active a label').text())
                })
        }

        $('.media-top-div .back, .media-top-div .arrow-back').on('click', scope.closePanel.bind(scope, false))

        if (this.containerType == this.containerTypes.STOP) {
            $(document).on('pagePopped', function(event) {
                if (event.page.id == scope.GALLERY_PANEL || scope.totalMedia == 1) {
                    scope.closePanel(false)
                }
            })
        }
        this._addKeyboardEvents()
        if (typeof AccessibilityController !== 'undefined') {
            AccessibilityController.subscribeToCallback(
                AccessibilityController.CallbackType.SPACE,
                scope._toggleVideoPlayer.bind(scope)
            )
        }
        //Shows a custom media panel
        helper.bind(events.showMediaPanel, function(event, data) {
            scope.setMediaType(data.mediaType)
            scope.panelVisible = true
        })

        //Hides the media panel
        helper.bind(events.closeMediaPanel, function(event, data) {
            scope.closePanel()
        })
    },

    showMediaType: function(mediaType, stopChanged) {
        stopChanged = stopChanged || false

        this.showPanel()

        // PREVENT RELOADING CURRENT MEDIA TYPE
        if (this.mediaType === mediaType && !stopChanged) {
            return
        }

        // HIGHLIGHT ACTIVE MEDIA SWITCH BUTTON
        $('.media-toggle-button')
            .removeClass('is-active')
            .filter('[media-type="' + mediaType + '"]')
            .addClass('is-active')

        // DESTROY PREVIOUS MEDIA
        this._destroyMedia()

        if (mediaType == this.mediaTypes.VIDEO) {
            this._fireAudioPlayEvents()
        }

        this.setMediaType(mediaType)

        this._loadStopMedia({
            mediaType: this.mediaType,
            locid: this.locid,
            instid: this.instid,
            tourid: this.tourid,
            stopid: this._getCurrentStopCB().id,
        })
    },

    showPanel: function() {
        if (window.YouVisit.HotspotsController) {
            HotspotsController.closeModal()
        }
        if (this.panelVisible) return

        this._mediaPanel.fadeIn()
        if (this.containerType != this.containerTypes.STOP) {
            mobileMenu.pushContainer({
                title: this._getCurrentStopCB().title,
                id: this.GALLERY_PANEL,
            })
        }

        $('.mediaPanelPopup').addClass('mediaModules')

        // SHOW STOPS FOR EACH MEDIA TYPE
        var stop = this._getCurrentStopCB()
        if (stop) {
            $('.media-toggle-button[media-type="panoramas"] .count').text(
                stop.totalPanos !== undefined ? stop.totalPanos : stop.panos.total
            )
            $('.media-toggle-button[media-type="photos"] .count').text(
                stop.totalPhotos !== undefined ? stop.totalPhotos : stop.photos.total
            )
            $('.media-toggle-button[media-type="videos"] .count').text(
                stop.totalVideos !== undefined ? stop.totalVideos : stop.videos.total
            )
        }

        this.panelVisible = true

        for (var i = 0; i < this._onOpenCb.length; i++) {
            this._onOpenCb[i]()
        }
    },

    closePanel: function(popContainer) {
        var scope = this
        if (this.panelVisible == false) return

        this._mediaPanel.fadeOut(function() {
            scope._mediaPanel.removeClass('one-media-item')
        })
        if (this.containerType == this.containerTypes.STOP && popContainer) {
            mobileMenu.popContainer()
        }

        // HACKISH SOLUTION: (SEARCH "HACKISH SOLUTION" IN THIS FILE). Remove the
        // hack once we close the popup
        if (this.totalMedia == 1) {
            document.ontouchmove = null
        }

        $(window).off('resize.mediaModules')

        for (var i = 0; i < this._onCloseCb.length; i++) {
            this._onCloseCb[i]()
        }

        this._destroyMedia()

        this.panelVisible = false

        $('.mediaPanelPopup').removeClass('mediaModules')
    },

    setTotalMedia: function() {
        this.totalMedia = $('ul.media-thumb-list').children().length
        if (this.totalMedia == 1) {
            this._mediaPanel.addClass('one-media-item')

            // HACKISH SOLUTION: This will fix a bug in Mobile that will cause
            // the page to bounce up/down when rotating a pano. Page should not
            // bounce. This only happens mysteriously when we have only one pano
            document.ontouchmove = function(e) {
                e.preventDefault()
            }
        } else {
            this._mediaPanel.removeClass('one-media-item')
        }
    },

    _addHooks: function() {
        var scope = this
        // Display media panel when clicked on the module icons
        //
        // TODO The following code should attach the event to the DOM even if the
        // elements don't exist. However, this is not working as such. Should be
        // investigated
        $('.mediaPanelPopup').on(
            'click',
            this.mediaTargetId + ' [class*=module-icon], .modules [class*=module-]',
            function() {
                var className = $(this).attr('class'),
                    matches = /module-(icon-)?([\S]+)/.exec(className),
                    mediaType = matches[matches.length - 1],
                    newStop = scope._getCurrentStopCB(),
                    stopChanged = false

                if (mediaType == 'panos') {
                    mediaType = scope.mediaTypes.PANO
                }

                if (scope.currentStopId !== newStop.id) {
                    stopChanged = true
                }
                scope.currentStopId = newStop.id
                $(this.mediaTargetId + ' .media-panel-title').html(newStop.title)

                scope.showMediaType(mediaType, stopChanged)
            }
        )

        $('.media-toggle-button').click(function() {
            var mediaType = $(this).attr('media-type'),
                count = $('.media-toggle-button[media-type="' + mediaType + '"] .count').text()
            if (+count > 0) {
                scope.showMediaType(mediaType, false)
            }
        })
    },

    _resizeEvent: function() {
        if (this.mediaType == this.mediaTypes.PANO) {
            var mediaDisplay = $(this.mediaTargetId).find('#mediaDisplay')
            this._panoPlayer.setSize(mediaDisplay.width(), mediaDisplay.height())
        }
    },

    _testMobileHeader: function() {
        if ($('.explore-button').length !== 0) {
            $('#media-side-bar').addClass('tall-header')
        } else {
            $('#media-side-bar').removeClass('tall-header')
        }
    },

    /**
     * Toggle video player
     */
    _toggleVideoPlayer: function() {
        if (this._videoPlayer) {
            if (this._videoPlayer.isPlaying()) {
                this._videoPlayer.pause()
            } else {
                this._videoPlayer.play()
            }
        }
    },

    _addKeyboardEvents: function() {
        var scope = this

        if (this.isAda) {
            // Make media gallery tabbable (was not tabbable before)
            $('div.media-scrollable')
                .find(':tabbable')
                .first()
                .focus()
        }

        $(document).keydown(function(e) {
            var $target = $(e.target)

            // Skip user-input elements. We use a blacklist-style approach here, because
            // in all other situations we want the global next/previous behavior overridden,
            // and there's no clean way to whitelist target elements for that behavior
            if (!$target.is('input, textarea, select')) {
                if (e.keyCode == 37) {
                    scope._previousMedia()
                    return false
                } else if (e.keyCode == 39) {
                    scope._nextMedia()
                    return false
                }
            }
        })
    },

    _fireAudioStopEvents: function() {
        for (var i = 0; i < this._onAudioStopCb.length; i++) {
            this._onAudioStopCb[i]()
        }
    },

    _fireAudioPlayEvents: function() {
        for (var i = 0; i < this._onAudioPlayCb.length; i++) {
            this._onAudioPlayCb[i]()
        }
    },

    onClose: function(cb) {
        this._onCloseCb.push(cb)
        return this
    },

    onOpen: function(cb) {
        this._onOpenCb.push(cb)
        return this
    },

    onAudioPlay: function(cb) {
        this._onAudioPlayCb.push(cb)
        return this
    },

    onAudioStop: function(cb) {
        this._onAudioStopCb.push(cb)
        return this
    },

    _setImageSize: function(img) {
        if (img.height() > img.width()) {
            img.addClass('portrait')
        } else {
            img.addClass('landscape')
        }
    },

    _getDescription: function(description) {
        if (description == null || description == '') {
            $(this.mediaTargetId)
                .find('.info-button ')
                .hide()
            $(this.mediaTargetId)
                .find('.description-box')
                .hide()
            return 'No description available'
        }
        $(this.mediaTargetId)
            .find('.info-button')
            .show()
        this._hideDescription
            ? $(this.mediaTargetId)
                  .find('.description-box')
                  .hide()
            : $(this.mediaTargetId)
                  .find('.description-box')
                  .show()
        return description
    },

    _loadCacheImage: function(cachePath) {
        if (cachePath == null) return
        this.cache_index = (this.cache_index + 1) % this.IMAGE_CACHE_SIZE
        if ($(this.mediaTargetId).find('#preloadedimage' + this.cache_index).length == 0) {
            $(this.mediaTargetId)
                .find('#main-photo')
                .parent()
                .append("<img id='preloadedimage" + this.cache_index + "'/>")
            $(this.mediaTargetId)
                .find('#preloadedimage' + this.cache_index)
                .css('display', 'none')
        }
        $(this.mediaTargetId)
            .find('#preloadedimage' + this.cache_index)
            .attr('src', cachePath)
    },

    _cacheImages: function() {
        var li = $(this.mediaTargetId)
            .find('.active')
            .parents('li')
        var ul = li.parent('ul').children()
        var index = ul.index(li)
        for (var ii = 1; ii <= this.IMAGE_CACHE_SIZE; ++ii) {
            this._loadCacheImage(
                $(this.mediaTargetId)
                    .find(ul[index + ii])
                    .find('div')
                    .data('largeurl')
            )
        }
    },

    _showPhoto: function() {
        var mediaDisplay = $(this.mediaTargetId).find('#mediaDisplay'),
            mainPhoto,
            imgurl,
            scope = this
        if ($(this.mediaTargetId).find('#mediaDisplay #main-photo').length == 0) {
            mediaDisplay.html("<img id='main-photo'>")
        }

        $(this.mediaTargetId)
            .find('#' + this.PLAYER_PANEL)
            .removeClass('videos photos panos')
            .addClass('photos')

        mainPhoto = $(this.mediaTargetId).find('#main-photo')
        imgurl = mainPhoto.attr('src')

        // Check if pano (ADA version), convert to flat image
        var _newImageURL = $(this.mediaTargetId)
            .find('.active')
            .data('largeurl')

        if (this.mediaType == this.mediaTypes.PANO) {
            var panoData = $(this.mediaTargetId)
                .find('.active')
                .data('pano')
            _newImageURL = panoData.path + '2048.jpg'
        }

        if (imgurl != _newImageURL) {
            ImageLoaderIcon.mainPanel = this.mediaTarget + ' #mediaDisplay'
            ImageLoaderIcon.show(500)
            this._cacheImages()
            mainPhoto.one('load', function() {
                setTimeout(function() {
                    ImageLoaderIcon.hide()
                    mainPhoto.fadeIn(500)
                }, 300)
            })
            mainPhoto.fadeOut(250, function() {
                mainPhoto.attr('src', _newImageURL)
                mainPhoto.attr(
                    'alt',
                    $(scope.mediaTargetId)
                        .find('.active a label')
                        .text()
                )
            })
        }

        $(this.mediaTargetId)
            .find('#loading_overlay')
            .fadeOut()
    },

    _showVideo: function() {
        var item = $(this.mediaTargetId).find('.active'),
            videoid = item.data('videoid'),
            videoType = item.data('videotype'),
            playback_type = item.data('playback-type'),
            mediaDisplay = $(this.mediaTargetId).find('#mediaDisplay'),
            scope = this

        $(this.mediaTargetId)
            .find('#' + this.PLAYER_PANEL)
            .removeClass('videos photos panos')
            .addClass('videos')

        if (this._videoPlayer) {
            this._videoPlayer.destroy()
        }

        //For accesibiltiy we are temp using 3rd party UI to allow for cc.
        this._videoPlayer = VideoPlayer.createPlayer({
            videoId: videoid,
            type: videoType,
            playback_type: playback_type,
            accessPlayerAPI: true,
            autoplay: this.autoPlay,
            uiBottomOffset: '45px',
            noPointerEvents: true,
            hideUI: VideoPlayer.types.AWS != videoType,
            controls: true,
        })

        this._videoPlayer.onReady(function() {
            $(scope.mediaTargetId)
                .find('#loading_overlay')
                .fadeOut()
        })

        this._videoPlayer.onPlay(function() {
            window.onVideoPlayed && window.onVideoPlayed()
        })

        this._videoPlayer.onFullscreen(function() {
            window.onVideoFullScreen && window.onVideoFullScreen()
        })

        mediaDisplay.html('')
        mediaDisplay.removeClass('photos, panos')
        setTimeout(function() {
            scope._videoPlayer.embedPlayer($(scope.mediaTargetId + ' #mediaDisplay')[0], '100%', '100%')
        }, 400)
    },

    _showPano: function() {
        var mediaDisplay = $(this.mediaTargetId).find('#mediaDisplay')

        var activePano = $(this.mediaTargetId)
            .find('.active')
            .data('pano')

        mediaDisplay.removeClass('photos')
        if (!activePano) {
            mediaDisplay.html('')
            return
        }

        $(this.mediaTargetId)
            .find('#' + this.PLAYER_PANEL)
            .removeClass('videos photos panos')
            .addClass('videos')

        //TODO - Fix setSource Method inside mediaObjects.js
        //
        if (this._panoPlayer && this._panoPlayer instanceof Panorama) {
            this._panoPlayer.destroy()
        }

        this._panoPlayer = new Panorama(activePano)
        this._panoPlayer.createHtml(
            this.mediaTarget + ' #mediaDisplay',
            '100%',
            '100%',
            activePano.hidebuttons,
            function(panoPlayer) {
                panoPlayer.on('panoLoaded', function() {
                    window.onPanoLoaded && window.onPanoLoaded()
                })
            }
        )

        $(this.mediaTargetId)
            .find('#loading_overlay')
            .fadeOut()
    },

    _showTitleAndDescription: function() {
        var description = $(this.mediaTargetId)
                .find('.active')
                .data('description'),
            title = $(this.mediaTargetId)
                .find('.active label')
                .html()
        $(this.mediaTargetId)
            .find('.description-text')
            .html(this._getDescription(description))
        if (this.containerType == this.containerTypes.STOP) {
            $(this.mediaTargetId + ' .media-panel-title').html(this._getCurrentStopCB().title + ' : ' + title)
        }
    },

    _showMedia: function(dontpush) {
        this._showTitleAndDescription()
        this._showModule()

        this._setNextPrevVisibility()

        // if(mobileMenu.getLast().id != this.PLAYER_PANEL && !dontpush) {
        // 	mobileMenu.pushContainer({
        // 		title : $(this.mediaTargetId).find('.active label').html(),
        // 		id : this.PLAYER_PANEL
        // 	});
        // }
    },

    _destroyMedia: function() {
        if (this.mediaType == this.mediaTypes.VIDEO) {
            this._fireAudioStopEvents()
        }

        if (this._panoPlayer) {
            this._panoPlayer.destroy()
            this._panoPlayer = null
        }
        if (this._videoPlayer) {
            this._videoPlayer.destroy()
            this._videoPlayer = null
        }

        this.mediaType = ''
    },

    _setNextPrevVisibility: function() {
        if (this.totalMedia < 2) {
            $(this.mediaTargetId)
                .find('.nextmedia')
                .hide()
            $(this.mediaTargetId)
                .find('.previousmedia')
                .hide()
        } else {
            var index = $(this.mediaTargetId)
                .find('.active')
                .parent()
                .index()
            if (index == 0) {
                $(this.mediaTargetId)
                    .find('.previousmedia')
                    .hide()
                $(this.mediaTargetId)
                    .find('.nextmedia')
                    .show()
            } else if (index == this.totalMedia - 1) {
                $(this.mediaTargetId)
                    .find('.previousmedia')
                    .show()
                $(this.mediaTargetId)
                    .find('.nextmedia')
                    .hide()
            } else {
                $(this.mediaTargetId)
                    .find('.previousmedia')
                    .show()
                $(this.mediaTargetId)
                    .find('.nextmedia')
                    .show()
            }
        }
    },

    _scroll: function() {
        var scope = this
        if (
            $(this.mediaTargetId)
                .find('.active')
                .position()
        ) {
            if (
                $(this.mediaTargetId)
                    .find('.active')
                    .position().top +
                    80 >
                    $(this.mediaTargetId)
                        .find('.main-media-section')
                        .height() ||
                $(this.mediaTargetId)
                    .find('.active')
                    .position().top < 0
            ) {
                $(this.mediaTargetId)
                    .find('.media-scrollable')
                    .stop()
                $(this.mediaTargetId)
                    .find('.media-scrollable')
                    .animate(
                        {
                            scrollTop:
                                $(scope.mediaTargetId)
                                    .find('.active')
                                    .position().top + $('.media-scrollable').scrollTop(),
                        },
                        1000
                    )
            }
        }
    },

    _nextMedia: function() {
        var next = $(this.mediaTargetId)
                .find('.active')
                .parent()
                .next()
                .children(),
            mediaType = next.data('mediatype')
        if (next.length != 0) {
            $(this.mediaTargetId)
                .find('div.imgthumb')
                .removeClass('active')
            next.addClass('active')
            this._showMedia()
            this._scroll()
        }
        mobileMenu.changeTitle(
            $(this.mediaTargetId)
                .find('.active label')
                .html()
        )
    },

    _previousMedia: function() {
        var previous = $(this.mediaTargetId)
                .find('.active')
                .parent()
                .prev()
                .children(),
            mediaType = previous.data('mediatype')
        if (previous.length != 0) {
            $(this.mediaTargetId)
                .find('div.imgthumb')
                .removeClass('active')
            previous.addClass('active')
            this._showMedia()
            this._scroll()
        }
        mobileMenu.changeTitle(
            $(this.mediaTargetId)
                .find('.active label')
                .html()
        )
    },

    _loadMedia: function() {
        var scope = this

        this.setTotalMedia()

        $(this.mediaTargetId)
            .find('img.loading')
            .show()
            .lazyload({
                container: $(scope.mediaTargetId).find('div.media-scrollable'),
                effect: 'fadeIn',
                threshold: 200,
                load: function() {
                    $(this).removeClass('loading')
                    scope._setImageSize($(this))
                    $(this)
                        .parent()
                        .addClass('imageloaded')
                    scope._cacheImages()
                },
            })
    },

    _loadStopMedia: function(data) {
        var scope = this,
            list = $(this.mediaTargetId).find('ul.media-thumb-list')
        this._prepareStopAnalytics(data)
        list.html('')
        list.before(
            '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQI12NgYAAAAAMAASDVlMcAAAAASUVORK5CYII=" class="refresh-list" alt="loading">'
        )
        $.ajax({
            type: 'GET',
            url: '/tour/MediaModules/getMediaByStop',
            data: data,
            success: function(data) {
                $(scope.mediaTargetId)
                    .find('.refresh-list')
                    .remove()
                list.html(data)
                scope._loadMedia()
                scope._showMedia(true)
                $(scope.mediaTargetId)
                    .find('.media-scrollable')
                    .scrollTop(0)

                $(scope.mediaTargetId)
                    .find('#media-side-bar')
                    .trigger('click')
            },
        })
    },

    _prepareStopAnalytics: function(data) {
        if (this.sendStopAnalytics && window.Analytics !== undefined) {
            var stop = this._getCurrentStopCB()
            data.panos = stop.panos.total > 0 ? 1 : 0
            data.videos = stop.videos.total > 0 ? 1 : 0
            data.photos = stop.photos.total > 0 ? 1 : 0
            data.mediaAnalytics = 1
            data.tourType = WalkingTour.tourType
            data.userkey = Analytics.userkey
            data.sessionId = Analytics.sessionId
        }
    },
}

$(document).ready(function() {
    _init()
})

export default MediaModules
